var exports = {
  "qV": "Skeleton.module__skeleton___RVZWWT",
  "Wq": "Skeleton.module__emphasisStrong___RVZWWT",
  "GN": "Skeleton.module__emphasisMuted___RVZWWT",
  "J": "Skeleton.module__radiusSharp___RVZWWT",
  "n0": "Skeleton.module__radiusSm___RVZWWT",
  "uF": "Skeleton.module__radiusMd___RVZWWT",
  "Ec": "Skeleton.module__radiusLg___RVZWWT",
  "xD": "Skeleton.module__radiusXl___RVZWWT",
  "cP": "Skeleton.module__radiusPill___RVZWWT",
  "by": "Skeleton.module__radiusCircle___RVZWWT",
};

module.exports = exports;
